import { storage } from './storage';

export type Theme = 'auto' | 'light' | 'dark';

export function applyTheme(t: Theme): void {
  const root = document.documentElement;
  if (t === 'auto') root.removeAttribute('data-theme');
  else root.setAttribute('data-theme', t);
  storage.set('clear.theme', t);
}

export const savedTheme = (): Theme => (storage.get('clear.theme') as Theme | null) ?? 'auto';
